import { createTelemetry, createTelemetryObject } from '@shared/core/analytics';

export type BrandCardType = 'brandPromoMosaic' | 'navbar' | 'productGrid' | 'categoryCarousel';

type ButtonInteractionType = { brandName: string; cardType: BrandCardType; partner?: string };
type PromoInteractionType = { brandName: string; cardType: BrandCardType; partnerId: string };

export const paidAdsForShopTelemetry = createTelemetryObject({
  actions: {
    brandCardClicked: ({ brandName, cardType, partner }: ButtonInteractionType) => ({
      category: 'PaidAdsForShop',
      action: 'ButtonInteracted',
      label: 'BrandCardClicked',
      extraInfo: {
        brandName,
        cardType,
        partner,
      },
    }),
    brandPromoViewed: ({ brandName, cardType, partnerId }: PromoInteractionType) => ({
      category: 'PaidAdsForShop',
      action: 'Viewed',
      label: 'BrandPromoViewed',
      extraInfo: {
        brandName,
        cardType,
        partnerId,
      },
    }),
    brandPromoClicked: ({ brandName, cardType, partnerId }: PromoInteractionType) => ({
      category: 'PaidAdsForShop',
      action: 'ButtonInteracted',
      label: 'BrandPromoClicked',
      extraInfo: {
        brandName,
        cardType,
        partnerId,
      },
    }),
  },
});

const { TelemetryProvider: PaidAdsForShopTelemetryProvider, useTelemetry: usePaidAdsForShopTelemetry } = createTelemetry(paidAdsForShopTelemetry);

type PaidAdsForShopTelemetry = ReturnType<typeof usePaidAdsForShopTelemetry>;

export { PaidAdsForShopTelemetryProvider, usePaidAdsForShopTelemetry, PaidAdsForShopTelemetry };
